import React from "react";
import { FormattedMessage } from "react-intl";
import { Typography, Table } from "antd";
import { useIntl } from "react-intl";
import IdOrPassport from "../../../components/tables/IdOrPassport";
import Address from "../../../components/tables/Address";
import Date from "../../../components/tables/Date";
import { getFullName } from "../../../components/util/helpers";

import moment from "moment";
var flatten = require("flat");

const { Title, Text } = Typography;
const Plan = (props) => {
  const { record } = props;
  const intl = useIntl();

  let sorted = record
    ? record.recurrent_work_events.map((obj) => ({
        ...obj,
      }))
    : [];
  sorted.sort((a, b) => a.weekday - b.weekday);
  const columns = [
    {
      title: intl.formatMessage({
        id: "app.plans.employee",
      }),
      dataIndex: "employee",
      render(text, record) {
        return record && record.employee ? (
          <Text>
            {getFullName(record.employee.surename, record.employee.first_name)}
          </Text>
        ) : null;
      },
      ellipsis: true,
      width: "130px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.idOrPassport",
      }),
      render(text, record) {
        return record && record.employee ? (
          <IdOrPassport
            record={flatten(record.employee, {
              safe: true,
            })}
          />
        ) : null;
      },
      ellipsis: true,
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.address",
      }),
      ellipsis: true,
      width: "140px",
      render(text, record) {
        return record && record.employee ? (
          <Address record={flatten(record.employee)} />
        ) : null;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.plans.weekday",
      }),
      dataIndex: "weekday",
      render(text) {
        return <Text>{moment.weekdays(text)}</Text>;
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.start_time",
      }),
      dataIndex: "start_time_minutes",
      render(text) {
        return (
          <Date
            text={moment().startOf("day").set("minute", text)}
            format={"HH:mm"}
          />
        );
      },
      width: "90px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.end_time",
      }),
      dataIndex: "end_time",
      render(text, record) {
        return (
          <Date
            text={moment()
              .startOf("day")
              .set(
                "minute",
                record.duration_minutes + record.start_time_minutes
              )}
            format={"HH:mm"}
          />
        );
      },
      width: "90px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.duration",
      }),
      dataIndex: "duration_minutes",
      render(text) {
        const hours = (text / 60).toFixed(2);
        return <Text>{hours}</Text>;
      },
      width: "70px",
    },
  ];

  return (
    <div>
      <Title level={5}>
        {<FormattedMessage id="app.plans.order_plan_title" />}
      </Title>

      <div>
        <Table
          dataSource={sorted}
          columns={columns}
          pagination={false}
          scroll={{
            y: window.innerHeight / 3,
          }}
          size="small"
        />
      </div>
      <div />
    </div>
  );
};

export default Plan;
